module.exports = __webpack_public_path__ + "img/action-action.77a9f929.svg";